// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"907680c2","453":"f5fe1e56","728":"66ddf1ba"}[chunkId] + ".chunk.js";
};